module.exports = __webpack_public_path__ + "static/media/map_step_osm.96c27b15.png";